// extracted by mini-css-extract-plugin
module.exports = {"text":"AnswerTextArea_text__1j78_"};